/* ==========================================================================
   HUMO BARRILES · TRAMO DE VUELO
   assets/humo-viaje.js
   El avión cruza y, al salir de cuadro, enciende el globo interactivo.
   ========================================================================== */
(function () {
  'use strict';

  var bloqueRuta = document.querySelector('[data-ruta-bloque]');
  function encender() {
    if (bloqueRuta) bloqueRuta.classList.add('is-visible');
  }

  var escena = document.getElementById('transitionScene');
  var tramo  = document.getElementById('transitionBridge');

  if (!escena || !tramo || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    encender();
    return;
  }

  document.body.appendChild(escena);

  function listo(fn) {
    var n = 0;
    var t = setInterval(function () {
      n++;
      if (window.gsap && window.ScrollTrigger) { clearInterval(t); fn(); }
      else if (n > 120) { clearInterval(t); encender(); }
    }, 100);
  }

  listo(function () {
    gsap.registerPlugin(ScrollTrigger);

    var cielo  = document.getElementById('transitionSky');
    var ruta   = document.getElementById('transitionRoute');
    var avion  = document.getElementById('transitionPlane');
    var brillo = document.getElementById('transitionFlare');

    var movil = window.innerWidth <= 767;
    var W = function () { return window.innerWidth; };
    var H = function () { return window.innerHeight; };

    var DESDE = { x: -0.30, y: 1.22 };
    var HASTA = { x: 1.30, y: -0.22 };
    function sitio(f) { return { x: W() * f.x, y: H() * f.y }; }

    gsap.set([avion, brillo], { xPercent: -50, yPercent: -50 });
    var ini = sitio(DESDE);
    gsap.set(escena, { opacity: 0, visibility: 'hidden' });
    gsap.set(cielo,  { opacity: 0 });
    gsap.set(ruta,   { opacity: 0, clipPath: 'inset(0 100% 0 0)' });
    gsap.set(brillo, { opacity: 0, scale: .8 });
    gsap.set(avion,  { opacity: 0, x: ini.x, y: ini.y, scale: .82, rotation: -6, filter: 'blur(0px)' });

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: tramo,
        start: 'top top',
        end: 'bottom bottom',
        scrub: 0.6,
        invalidateOnRefresh: true,
        onLeave: encender
      },
      defaults: { ease: 'none' }
    });

    tl.set(escena, { visibility: 'visible' }, 0)
      .to(escena, { opacity: 1, duration: .04 }, 0)

      .to(ruta, { opacity: 1, duration: .05 }, 0.02)
      .to(ruta, { clipPath: 'inset(0 0% 0 0)', duration: .56, ease: 'power1.inOut' }, 0.04)

      .to(avion, { opacity: 1, duration: .06 }, 0.02)
      .fromTo(avion,
        { x: function () { return sitio(DESDE).x; }, y: function () { return sitio(DESDE).y; }, scale: .82, rotation: -6 },
        { x: function () { return sitio(HASTA).x; }, y: function () { return sitio(HASTA).y; },
          scale: movil ? 1 : 1.12, rotation: 6, duration: .62, ease: 'power1.inOut' }, 0.02)

      .to(brillo, {
        opacity: movil ? .42 : .62, scale: 1.1, duration: .1, ease: 'power2.out',
        onUpdate: function () {
          var r = avion.getBoundingClientRect();
          gsap.set(brillo, { x: r.left + r.width / 2, y: r.top + r.height / 2 });
        }
      }, 0.28)
      .to(brillo, { opacity: 0, scale: .9, duration: .12, ease: 'power2.in' }, 0.40)

      /* el cielo se cierra detrás del avión */
      .to(cielo, { opacity: 1, duration: .18, ease: 'power2.inOut' }, 0.32)

      /* sale el avión y queda el cielo limpio */
      .to(avion, { opacity: 0, filter: 'blur(5px)', duration: .10, ease: 'power2.in' }, 0.62)
      .to(ruta,  { opacity: 0, duration: .10, ease: 'power1.in' }, 0.62)

      /* la escena se retira y debajo aparece el mundo */
      .add(encender, 0.70)
      .to(escena, { opacity: 0, duration: .22, ease: 'power1.inOut' }, 0.72)
      .set(escena, { visibility: 'hidden' }, 0.995);

    ScrollTrigger.refresh();

    /* red de seguridad: si el globo ya está en pantalla, se enciende sí o sí */
    if (bloqueRuta) {
      ScrollTrigger.create({
        trigger: bloqueRuta,
        start: 'top 85%',
        once: true,
        onEnter: encender
      });
    }
  });
})();
